var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "excel"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29217",
    "data-name": "Rectangle 29217",
    width: 50,
    height: 50,
    transform: "translate(757 433)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_642",
    "data-name": "Mask Group 642",
    transform: "translate(-757 -433)",
    clipPath: "url(#excel)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_78_",
    "data-name": "svgexport-6 (78)",
    transform: "translate(763.3 433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11472",
    "data-name": "Group 11472",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11512",
    "data-name": "Path 11512",
    d: "M14.324,0H31.046L45.21,14.777V43.486A6.514,6.514,0,0,1,38.7,50H14.324a6.514,6.514,0,0,1-6.511-6.511V6.511A6.514,6.514,0,0,1,14.324,0Z",
    transform: "translate(-7.812)",
    fill: "#1a975a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11471",
    "data-name": "Group 11471",
    transform: "translate(11.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11513",
    "data-name": "Path 11513",
    d: "M36.6,0V14.65H50.782Z",
    transform: "translate(-24.399)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11514",
    "data-name": "Path 11514",
    d: "M21.471,42.4h6.638v2.516H21.471Zm8.71-12.853H36.84V32.04H30.181Zm-8.71,0h6.638V32.04H21.471Zm8.71,4.228H36.84v2.516H30.181Zm-8.71,0h6.638v2.516H21.471Zm8.71,4.4H36.84v2.516H30.181Zm-8.71,0h6.638v2.516H21.471Zm8.71,4.228H36.84v2.516H30.181Z",
    transform: "translate(-21.471 -5.72)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.ae9622a9435407a8cca21d92d98f1560.svg";
export { ForwardRef as ReactComponent };